import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(private readonly _messageService: MessageService) {}

  public showSuccess(
    message: string,
    options?: { closable?: boolean; life?: number }
  ) {
    this._messageService.add({
      severity: 'success',
      detail: message,
      closable: false, // Default to true if not provided
      life: options?.life ?? 3000, // Default duration to 3000ms
      data: { clossable: options?.closable ?? true },
    });
  }

  public showError(
    message: string,
    options?: { closable?: boolean; life?: number }
  ) {
    this._messageService.add({
      severity: 'error',
      detail: message,
      closable: false,
      life: options?.life ?? 3000,
      data: { clossable: options?.closable ?? true },
    });
  }

  public showInfo(
    message: string,
    options?: { closable?: boolean; life?: number }
  ) {
    this._messageService.add({
      severity: 'info',
      detail: message,
      closable: false,
      life: options?.life ?? 3000,
      data: { clossable: options?.closable ?? true },
    });
  }

  public showWarning(
    message: string,
    options?: { closable?: boolean; life?: number }
  ) {
    this._messageService.add({
      severity: 'warn',
      detail: message,
      closable: false,
      life: options?.life ?? 3000,
      data: { clossable: options?.closable ?? true },
    });
  }

  public clearToast(key: string) {
    this._messageService.clear(key);
  }
}
